/**
 * The `origin` values a client may send on a report, mirroring
 * Report::ORIGIN_REPORT_FORM and Report::ORIGIN_BLOCK_FLOW in
 * app/Model/Moderation/Report.php. The server records the value in
 * `reports.origin` so moderation automation can weigh a one-click report
 * differently from a deliberately composed one.
 *
 * Every report surface must send one. The server does not guess: an origin it
 * was not given is recorded as null, meaning unknown, and a surface that stops
 * sending its origin silently drops out of that distinction rather than
 * defaulting into the wrong half of it.
 *
 * `system` is deliberately absent. It is stamped server-side on a write path no
 * request can reach, and a client naming it would only have the value discarded.
 *
 * Single-sourced here rather than inlined per modal for the same reason the PHP
 * side keeps them on the model: several senders share the values, and a literal
 * copied into each one drifts. tests/unit/Model/Moderation/ReportOriginJsMirrorTest.php
 * pins this file against the PHP constants.
 */
export const REPORT_FORM_ORIGIN = 'report_form';
export const BLOCK_FLOW_ORIGIN = 'block_flow';
